<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="cont" title="Contents">
<p class="fmh1"><span class="right_1" epub:type="pagebreak" id="page_3" title="3"><i>Contents</i></span></p>
<p class="tocc" id="int"><a href="#/text/Introduction">INTRODUCTION</a></p>
<p class="tocc" id="ch1"><a href="#/text/Chapter001">CHAPTER 1: <i>What You Need to Get Started</i></a></p>
<p class="tocc" id="ch2"><span href="#/text/Chapter002" title="Link target outside of Sample">CHAPTER 2: <i>Brush Pen Ergonomics</i></span></p>
<p class="tocc" id="ch3"><span href="#/text/Chapter003" title="Link target outside of Sample">CHAPTER 3: <i>Brush Pen Warm-Up</i></span></p>
<p class="tocc" id="ch4"><span href="#/text/Chapter004" title="Link target outside of Sample">CHAPTER 4: <i>Basic Strokes</i></span></p>
<p class="tocc" id="ch5"><span href="#/text/Chapter005" title="Link target outside of Sample">CHAPTER 5: <i>Connecting Basic Strokes</i></span></p>
<p class="tocc" id="ch6"><span href="#/text/Chapter006" title="Link target outside of Sample">CHAPTER 6: <i>Lowercase Alphabet</i></span></p>
<p class="tocc" id="ch7"><span href="#/text/Chapter007" title="Link target outside of Sample">CHAPTER 7: <i>Uppercase Alphabet</i></span></p>
<p class="tocc" id="ch8"><span href="#/text/Chapter008" title="Link target outside of Sample">CHAPTER 8: <i>Connecting Letters</i></span></p>
<p class="tocc" id="ch9"><span href="#/text/Chapter009" title="Link target outside of Sample">CHAPTER 9: <i>Words</i></span></p>
<p class="tocc" id="ch10"><span href="#/text/Chapter010" title="Link target outside of Sample">CHAPTER 10: <i>Numbers and Symbols</i></span></p>
<p class="tocc" id="ch11"><span href="#/text/Chapter011" title="Link target outside of Sample">CHAPTER 11: <i>Developing Style</i></span></p>
<p class="tocc" id="app"><span href="#/text/Appendix" title="Link target outside of Sample">APPENDIX</span></p>
<p class="tocc" id="ata"><span href="#/text/About_the_Author" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?59d71dfc